import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {OffCanvasType} from "../../definitions/types";

export const name = "artworkOffCanvas";

const artworkOffCanvas = createSlice({
    name: name,
    initialState: {
        value: {
            show: false,
        } as OffCanvasType
    },
    reducers: {
        setShow: (state, action: PayloadAction<boolean>) => {
            state.value = {
                ...state.value,
                show: action.payload
            }
        }
    }
});

export const artworkOffCanvasActions = {
    setShow: artworkOffCanvas.actions.setShow
};

export default artworkOffCanvas.reducer;